import React from 'react';
import {Modal, ModalBody} from 'reactstrap';
import './style.scss';

const IconModal = ({isOpened, Icon, body, onClose}) => (
  <Modal
    style={{zIndex: 1500}}
    isOpen={isOpened}
    toggle={onClose}
    centered
    className="icon-modal"
  >
    <ModalBody>
      <div className="d-flex icons-wrapper">
        <div className="icon-container">
          <img alt="test" src={Icon} />
        </div>
        <div className="text-conatiner">{body}</div>
      </div>
    </ModalBody>
  </Modal>
);

export default IconModal;
